/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-mixed-operators, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars, default-case, jsdoc/require-param*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
var $Object = $util.global.Object, $undefined = $util.global.undefined, $Error = $util.global.Error;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.loomi = (function() {

    /**
     * Namespace loomi.
     * @exports loomi
     * @namespace
     */
    var loomi = {};

    loomi.binary = (function() {

        /**
         * Namespace binary.
         * @memberof loomi
         * @namespace
         */
        var binary = {};

        binary.Catalog = (function() {

            /**
             * Properties of a Catalog.
             * @typedef {Object} loomi.binary.Catalog.$Properties
             * @property {Array.<loomi.binary.Collection.$Properties>|null} [collections] Catalog collections
             * @property {Array.<loomi.binary.CatalogProduct.$Properties>|null} [products] Catalog products
             * @property {Array.<string>|null} [productTags] Catalog productTags
             * @property {boolean|null} [reviewsEnabled] Catalog reviewsEnabled
             * @property {Array.<string>|null} [currencies] Catalog currencies
             * @property {number|null} [productCount] Catalog productCount
             * @property {Array.<string>|null} [customerTags] Catalog customerTags
             * @property {string|null} [mainAttribute] Catalog mainAttribute
             * @property {Array.<string>|null} [mainAttributeOptions] Catalog mainAttributeOptions
             * @property {Array.<string>|null} [productTagDictionary] Catalog productTagDictionary
             * @property {Uint8Array|null} [productTagRelationData] Catalog productTagRelationData
             * @property {Uint8Array|null} [productTagRelationOffsets] Catalog productTagRelationOffsets
             * @property {Uint8Array|null} [productTagRelationFormats] Catalog productTagRelationFormats
             * @property {Array.<string>|null} [productCollectionDictionary] Catalog productCollectionDictionary
             * @property {Uint8Array|null} [productCollectionRelationData] Catalog productCollectionRelationData
             * @property {Uint8Array|null} [productCollectionRelationOffsets] Catalog productCollectionRelationOffsets
             * @property {Uint8Array|null} [productCollectionRelationFormats] Catalog productCollectionRelationFormats
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */

            /**
             * Properties of a Catalog.
             * @memberof loomi.binary
             * @interface ICatalog
             * @augments loomi.binary.Catalog.$Properties
             * @deprecated Use loomi.binary.Catalog.$Properties instead.
             */

            /**
             * Shape of a Catalog.
             * @typedef {loomi.binary.Catalog.$Properties} loomi.binary.Catalog.$Shape
             */

            /**
             * Constructs a new Catalog.
             * @memberof loomi.binary
             * @classdesc Represents a Catalog.
             * @constructor
             * @param {loomi.binary.Catalog.$Properties=} [properties] Properties to set
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */
            var Catalog = function (properties) {
                this.collections = [];
                this.products = [];
                this.productTags = [];
                this.currencies = [];
                this.customerTags = [];
                this.mainAttributeOptions = [];
                this.productTagDictionary = [];
                this.productCollectionDictionary = [];
                if (properties)
                    for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            };

            /**
             * Catalog collections.
             * @member {Array.<loomi.binary.Collection.$Properties>} collections
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.collections = $util.emptyArray;

            /**
             * Catalog products.
             * @member {Array.<loomi.binary.CatalogProduct.$Properties>} products
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.products = $util.emptyArray;

            /**
             * Catalog productTags.
             * @member {Array.<string>} productTags
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productTags = $util.emptyArray;

            /**
             * Catalog reviewsEnabled.
             * @member {boolean} reviewsEnabled
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.reviewsEnabled = false;

            /**
             * Catalog currencies.
             * @member {Array.<string>} currencies
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.currencies = $util.emptyArray;

            /**
             * Catalog productCount.
             * @member {number} productCount
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productCount = 0;

            /**
             * Catalog customerTags.
             * @member {Array.<string>} customerTags
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.customerTags = $util.emptyArray;

            /**
             * Catalog mainAttribute.
             * @member {string} mainAttribute
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.mainAttribute = "";

            /**
             * Catalog mainAttributeOptions.
             * @member {Array.<string>} mainAttributeOptions
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.mainAttributeOptions = $util.emptyArray;

            /**
             * Catalog productTagDictionary.
             * @member {Array.<string>} productTagDictionary
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productTagDictionary = $util.emptyArray;

            /**
             * Catalog productTagRelationData.
             * @member {Uint8Array} productTagRelationData
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productTagRelationData = $util.newBuffer([]);

            /**
             * Catalog productTagRelationOffsets.
             * @member {Uint8Array} productTagRelationOffsets
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productTagRelationOffsets = $util.newBuffer([]);

            /**
             * Catalog productTagRelationFormats.
             * @member {Uint8Array} productTagRelationFormats
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productTagRelationFormats = $util.newBuffer([]);

            /**
             * Catalog productCollectionDictionary.
             * @member {Array.<string>} productCollectionDictionary
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productCollectionDictionary = $util.emptyArray;

            /**
             * Catalog productCollectionRelationData.
             * @member {Uint8Array} productCollectionRelationData
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productCollectionRelationData = $util.newBuffer([]);

            /**
             * Catalog productCollectionRelationOffsets.
             * @member {Uint8Array} productCollectionRelationOffsets
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productCollectionRelationOffsets = $util.newBuffer([]);

            /**
             * Catalog productCollectionRelationFormats.
             * @member {Uint8Array} productCollectionRelationFormats
             * @memberof loomi.binary.Catalog
             * @instance
             */
            Catalog.prototype.productCollectionRelationFormats = $util.newBuffer([]);

            /**
             * Encodes the specified Catalog message. Does not implicitly {@link loomi.binary.Catalog.verify|verify} messages.
             * @function encode
             * @memberof loomi.binary.Catalog
             * @static
             * @param {loomi.binary.Catalog.$Properties} message Catalog message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Catalog.encode = function (message, writer, _depth) {
                if (!writer)
                    writer = $Writer.create();
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                if (message.collections != null && message.collections.length)
                    for (var i = 0; i < message.collections.length; ++i)
                        $root.loomi.binary.Collection.encode(message.collections[i], writer.uint32(/* id 1, wireType 2 =*/10).fork(), _depth + 1).ldelim();
                if (message.products != null && message.products.length)
                    for (var i = 0; i < message.products.length; ++i)
                        $root.loomi.binary.CatalogProduct.encode(message.products[i], writer.uint32(/* id 2, wireType 2 =*/18).fork(), _depth + 1).ldelim();
                if (message.productTags != null && message.productTags.length)
                    for (var i = 0; i < message.productTags.length; ++i)
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.productTags[i]);
                if (message.reviewsEnabled != null && $Object.hasOwnProperty.call(message, "reviewsEnabled") && message.reviewsEnabled !== false)
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.reviewsEnabled);
                if (message.currencies != null && message.currencies.length)
                    for (var i = 0; i < message.currencies.length; ++i)
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.currencies[i]);
                if (message.productCount != null && $Object.hasOwnProperty.call(message, "productCount") && message.productCount !== 0)
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.productCount);
                if (message.customerTags != null && message.customerTags.length)
                    for (var i = 0; i < message.customerTags.length; ++i)
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.customerTags[i]);
                if (message.mainAttribute != null && $Object.hasOwnProperty.call(message, "mainAttribute") && message.mainAttribute !== "")
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.mainAttribute);
                if (message.mainAttributeOptions != null && message.mainAttributeOptions.length)
                    for (var i = 0; i < message.mainAttributeOptions.length; ++i)
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.mainAttributeOptions[i]);
                if (message.productTagDictionary != null && message.productTagDictionary.length)
                    for (var i = 0; i < message.productTagDictionary.length; ++i)
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.productTagDictionary[i]);
                if (message.productTagRelationData != null && $Object.hasOwnProperty.call(message, "productTagRelationData") && message.productTagRelationData.length)
                    writer.uint32(/* id 12, wireType 2 =*/98).bytes(message.productTagRelationData);
                if (message.productTagRelationOffsets != null && $Object.hasOwnProperty.call(message, "productTagRelationOffsets") && message.productTagRelationOffsets.length)
                    writer.uint32(/* id 13, wireType 2 =*/106).bytes(message.productTagRelationOffsets);
                if (message.productTagRelationFormats != null && $Object.hasOwnProperty.call(message, "productTagRelationFormats") && message.productTagRelationFormats.length)
                    writer.uint32(/* id 14, wireType 2 =*/114).bytes(message.productTagRelationFormats);
                if (message.productCollectionDictionary != null && message.productCollectionDictionary.length)
                    for (var i = 0; i < message.productCollectionDictionary.length; ++i)
                        writer.uint32(/* id 15, wireType 2 =*/122).string(message.productCollectionDictionary[i]);
                if (message.productCollectionRelationData != null && $Object.hasOwnProperty.call(message, "productCollectionRelationData") && message.productCollectionRelationData.length)
                    writer.uint32(/* id 16, wireType 2 =*/130).bytes(message.productCollectionRelationData);
                if (message.productCollectionRelationOffsets != null && $Object.hasOwnProperty.call(message, "productCollectionRelationOffsets") && message.productCollectionRelationOffsets.length)
                    writer.uint32(/* id 17, wireType 2 =*/138).bytes(message.productCollectionRelationOffsets);
                if (message.productCollectionRelationFormats != null && $Object.hasOwnProperty.call(message, "productCollectionRelationFormats") && message.productCollectionRelationFormats.length)
                    writer.uint32(/* id 18, wireType 2 =*/146).bytes(message.productCollectionRelationFormats);
                if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                    for (var i = 0; i < message.$unknowns.length; ++i)
                        writer.raw(message.$unknowns[i]);
                return writer;
            };

            /**
             * Decodes a Catalog message from the specified reader or buffer.
             * @function decode
             * @memberof loomi.binary.Catalog
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {loomi.binary.Catalog & loomi.binary.Catalog.$Shape} Catalog
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Catalog.decode = function (reader, length, _end, _depth, _target) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $Reader.recursionLimit)
                    throw $Error("max depth exceeded");
                var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.loomi.binary.Catalog(), value;
                while (reader.pos < end) {
                    var start = reader.pos;
                    var tag = reader.tag();
                    if (tag === _end) {
                        _end = $undefined;
                        break;
                    }
                    var wireType = tag & 7;
                    switch (tag >>>= 3) {
                    case 1: {
                            if (wireType !== 2)
                                break;
                            if (!(message.collections && message.collections.length))
                                message.collections = [];
                            message.collections.push($root.loomi.binary.Collection.decode(reader, reader.uint32(), $undefined, _depth + 1));
                            continue;
                        }
                    case 2: {
                            if (wireType !== 2)
                                break;
                            if (!(message.products && message.products.length))
                                message.products = [];
                            message.products.push($root.loomi.binary.CatalogProduct.decode(reader, reader.uint32(), $undefined, _depth + 1));
                            continue;
                        }
                    case 3: {
                            if (wireType !== 2)
                                break;
                            if (!(message.productTags && message.productTags.length))
                                message.productTags = [];
                            message.productTags.push(reader.stringVerify());
                            continue;
                        }
                    case 4: {
                            if (wireType !== 0)
                                break;
                            if (value = reader.bool())
                                message.reviewsEnabled = value;
                            else
                                delete message.reviewsEnabled;
                            continue;
                        }
                    case 5: {
                            if (wireType !== 2)
                                break;
                            if (!(message.currencies && message.currencies.length))
                                message.currencies = [];
                            message.currencies.push(reader.stringVerify());
                            continue;
                        }
                    case 6: {
                            if (wireType !== 0)
                                break;
                            if (value = reader.int32())
                                message.productCount = value;
                            else
                                delete message.productCount;
                            continue;
                        }
                    case 7: {
                            if (wireType !== 2)
                                break;
                            if (!(message.customerTags && message.customerTags.length))
                                message.customerTags = [];
                            message.customerTags.push(reader.stringVerify());
                            continue;
                        }
                    case 8: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.stringVerify()).length)
                                message.mainAttribute = value;
                            else
                                delete message.mainAttribute;
                            continue;
                        }
                    case 9: {
                            if (wireType !== 2)
                                break;
                            if (!(message.mainAttributeOptions && message.mainAttributeOptions.length))
                                message.mainAttributeOptions = [];
                            message.mainAttributeOptions.push(reader.stringVerify());
                            continue;
                        }
                    case 11: {
                            if (wireType !== 2)
                                break;
                            if (!(message.productTagDictionary && message.productTagDictionary.length))
                                message.productTagDictionary = [];
                            message.productTagDictionary.push(reader.stringVerify());
                            continue;
                        }
                    case 12: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.bytes()).length)
                                message.productTagRelationData = value;
                            else
                                delete message.productTagRelationData;
                            continue;
                        }
                    case 13: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.bytes()).length)
                                message.productTagRelationOffsets = value;
                            else
                                delete message.productTagRelationOffsets;
                            continue;
                        }
                    case 14: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.bytes()).length)
                                message.productTagRelationFormats = value;
                            else
                                delete message.productTagRelationFormats;
                            continue;
                        }
                    case 15: {
                            if (wireType !== 2)
                                break;
                            if (!(message.productCollectionDictionary && message.productCollectionDictionary.length))
                                message.productCollectionDictionary = [];
                            message.productCollectionDictionary.push(reader.stringVerify());
                            continue;
                        }
                    case 16: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.bytes()).length)
                                message.productCollectionRelationData = value;
                            else
                                delete message.productCollectionRelationData;
                            continue;
                        }
                    case 17: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.bytes()).length)
                                message.productCollectionRelationOffsets = value;
                            else
                                delete message.productCollectionRelationOffsets;
                            continue;
                        }
                    case 18: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.bytes()).length)
                                message.productCollectionRelationFormats = value;
                            else
                                delete message.productCollectionRelationFormats;
                            continue;
                        }
                    }
                    reader.skipType(wireType, _depth, tag);
                    if (!reader.discardUnknown) {
                        $util.makeProp(message, "$unknowns", false);
                        (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                    }
                }
                if (_end !== $undefined)
                    throw $Error("missing end group");
                return message;
            };

            /**
             * Gets the type url for Catalog
             * @function getTypeUrl
             * @memberof loomi.binary.Catalog
             * @static
             * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
             * @returns {string} The type url
             */
            Catalog.getTypeUrl = function(prefix) {
                if (prefix === $undefined)
                    prefix = "type.googleapis.com";
                return prefix + "/loomi.binary.Catalog";
            };

            return Catalog;
        })();

        binary.CatalogProduct = (function() {

            /**
             * Properties of a CatalogProduct.
             * @typedef {Object} loomi.binary.CatalogProduct.$Properties
             * @property {number|Long|null} [id] CatalogProduct id
             * @property {Array.<string>|null} [collections] CatalogProduct collections
             * @property {string|null} [handle] CatalogProduct handle
             * @property {loomi.binary.Image.$Properties|null} [image] CatalogProduct image
             * @property {number|null} [price] CatalogProduct price
             * @property {string|null} [productType] CatalogProduct productType
             * @property {number|null} [rank] CatalogProduct rank
             * @property {Array.<string>|null} [tags] CatalogProduct tags
             * @property {string|null} [title] CatalogProduct title
             * @property {Array.<loomi.binary.ProductOption.$Properties>|null} [options] CatalogProduct options
             * @property {Array.<number|Long>|null} [variantIds] CatalogProduct variantIds
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */

            /**
             * Properties of a CatalogProduct.
             * @memberof loomi.binary
             * @interface ICatalogProduct
             * @augments loomi.binary.CatalogProduct.$Properties
             * @deprecated Use loomi.binary.CatalogProduct.$Properties instead.
             */

            /**
             * Shape of a CatalogProduct.
             * @typedef {loomi.binary.CatalogProduct.$Properties} loomi.binary.CatalogProduct.$Shape
             */

            /**
             * Constructs a new CatalogProduct.
             * @memberof loomi.binary
             * @classdesc Represents a CatalogProduct.
             * @constructor
             * @param {loomi.binary.CatalogProduct.$Properties=} [properties] Properties to set
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */
            var CatalogProduct = function (properties) {
                this.collections = [];
                this.tags = [];
                this.options = [];
                this.variantIds = [];
                if (properties)
                    for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            };

            /**
             * CatalogProduct id.
             * @member {number|Long} id
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * CatalogProduct collections.
             * @member {Array.<string>} collections
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.collections = $util.emptyArray;

            /**
             * CatalogProduct handle.
             * @member {string} handle
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.handle = "";

            /**
             * CatalogProduct image.
             * @member {loomi.binary.Image.$Properties|null|undefined} image
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.image = null;

            /**
             * CatalogProduct price.
             * @member {number} price
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.price = 0;

            /**
             * CatalogProduct productType.
             * @member {string} productType
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.productType = "";

            /**
             * CatalogProduct rank.
             * @member {number} rank
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.rank = 0;

            /**
             * CatalogProduct tags.
             * @member {Array.<string>} tags
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.tags = $util.emptyArray;

            /**
             * CatalogProduct title.
             * @member {string} title
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.title = "";

            /**
             * CatalogProduct options.
             * @member {Array.<loomi.binary.ProductOption.$Properties>} options
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.options = $util.emptyArray;

            /**
             * CatalogProduct variantIds.
             * @member {Array.<number|Long>} variantIds
             * @memberof loomi.binary.CatalogProduct
             * @instance
             */
            CatalogProduct.prototype.variantIds = $util.emptyArray;

            /**
             * Encodes the specified CatalogProduct message. Does not implicitly {@link loomi.binary.CatalogProduct.verify|verify} messages.
             * @function encode
             * @memberof loomi.binary.CatalogProduct
             * @static
             * @param {loomi.binary.CatalogProduct.$Properties} message CatalogProduct message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CatalogProduct.encode = function (message, writer, _depth) {
                if (!writer)
                    writer = $Writer.create();
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                if (message.id != null && $Object.hasOwnProperty.call(message, "id") && (typeof message.id === "object" ? message.id.low || message.id.high : message.id !== 0))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                if (message.collections != null && message.collections.length)
                    for (var i = 0; i < message.collections.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.collections[i]);
                if (message.handle != null && $Object.hasOwnProperty.call(message, "handle") && message.handle !== "")
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.handle);
                if (message.image != null && $Object.hasOwnProperty.call(message, "image"))
                    $root.loomi.binary.Image.encode(message.image, writer.uint32(/* id 4, wireType 2 =*/34).fork(), _depth + 1).ldelim();
                if (message.price != null && $Object.hasOwnProperty.call(message, "price") && !$Object.is(message.price, 0))
                    writer.uint32(/* id 5, wireType 5 =*/45).float(message.price);
                if (message.productType != null && $Object.hasOwnProperty.call(message, "productType") && message.productType !== "")
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.productType);
                if (message.rank != null && $Object.hasOwnProperty.call(message, "rank") && message.rank !== 0)
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.rank);
                if (message.tags != null && message.tags.length)
                    for (var i = 0; i < message.tags.length; ++i)
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.tags[i]);
                if (message.title != null && $Object.hasOwnProperty.call(message, "title") && message.title !== "")
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.title);
                if (message.options != null && message.options.length)
                    for (var i = 0; i < message.options.length; ++i)
                        $root.loomi.binary.ProductOption.encode(message.options[i], writer.uint32(/* id 10, wireType 2 =*/82).fork(), _depth + 1).ldelim();
                if (message.variantIds != null && message.variantIds.length)
                    writer.uint32(/* id 11, wireType 2 =*/90).int64s(message.variantIds);
                if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                    for (var i = 0; i < message.$unknowns.length; ++i)
                        writer.raw(message.$unknowns[i]);
                return writer;
            };

            /**
             * Decodes a CatalogProduct message from the specified reader or buffer.
             * @function decode
             * @memberof loomi.binary.CatalogProduct
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {loomi.binary.CatalogProduct & loomi.binary.CatalogProduct.$Shape} CatalogProduct
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CatalogProduct.decode = function (reader, length, _end, _depth, _target) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $Reader.recursionLimit)
                    throw $Error("max depth exceeded");
                var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.loomi.binary.CatalogProduct(), value;
                while (reader.pos < end) {
                    var start = reader.pos;
                    var tag = reader.tag();
                    if (tag === _end) {
                        _end = $undefined;
                        break;
                    }
                    var wireType = tag & 7;
                    switch (tag >>>= 3) {
                    case 1: {
                            if (wireType !== 0)
                                break;
                            if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                                message.id = value;
                            else
                                delete message.id;
                            continue;
                        }
                    case 2: {
                            if (wireType !== 2)
                                break;
                            if (!(message.collections && message.collections.length))
                                message.collections = [];
                            message.collections.push(reader.stringVerify());
                            continue;
                        }
                    case 3: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.stringVerify()).length)
                                message.handle = value;
                            else
                                delete message.handle;
                            continue;
                        }
                    case 4: {
                            if (wireType !== 2)
                                break;
                            message.image = $root.loomi.binary.Image.decode(reader, reader.uint32(), $undefined, _depth + 1, message.image);
                            continue;
                        }
                    case 5: {
                            if (wireType !== 5)
                                break;
                            if (!$Object.is(value = reader.float(), 0))
                                message.price = value;
                            else
                                delete message.price;
                            continue;
                        }
                    case 6: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.stringVerify()).length)
                                message.productType = value;
                            else
                                delete message.productType;
                            continue;
                        }
                    case 7: {
                            if (wireType !== 0)
                                break;
                            if (value = reader.int32())
                                message.rank = value;
                            else
                                delete message.rank;
                            continue;
                        }
                    case 8: {
                            if (wireType !== 2)
                                break;
                            if (!(message.tags && message.tags.length))
                                message.tags = [];
                            message.tags.push(reader.stringVerify());
                            continue;
                        }
                    case 9: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.stringVerify()).length)
                                message.title = value;
                            else
                                delete message.title;
                            continue;
                        }
                    case 10: {
                            if (wireType !== 2)
                                break;
                            if (!(message.options && message.options.length))
                                message.options = [];
                            message.options.push($root.loomi.binary.ProductOption.decode(reader, reader.uint32(), $undefined, _depth + 1));
                            continue;
                        }
                    case 11: {
                            if (wireType === 2) {
                                if (!(message.variantIds && message.variantIds.length))
                                    message.variantIds = [];
                                reader.int64s(message.variantIds);
                                continue;
                            }
                            if (wireType !== 0)
                                break;
                            if (!(message.variantIds && message.variantIds.length))
                                message.variantIds = [];
                            message.variantIds.push(reader.int64());
                            continue;
                        }
                    }
                    reader.skipType(wireType, _depth, tag);
                    if (!reader.discardUnknown) {
                        $util.makeProp(message, "$unknowns", false);
                        (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                    }
                }
                if (_end !== $undefined)
                    throw $Error("missing end group");
                return message;
            };

            /**
             * Gets the type url for CatalogProduct
             * @function getTypeUrl
             * @memberof loomi.binary.CatalogProduct
             * @static
             * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
             * @returns {string} The type url
             */
            CatalogProduct.getTypeUrl = function(prefix) {
                if (prefix === $undefined)
                    prefix = "type.googleapis.com";
                return prefix + "/loomi.binary.CatalogProduct";
            };

            return CatalogProduct;
        })();

        binary.ProductOption = (function() {

            /**
             * Properties of a ProductOption.
             * @typedef {Object} loomi.binary.ProductOption.$Properties
             * @property {string|null} [name] ProductOption name
             * @property {Array.<string>|null} [values] ProductOption values
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */

            /**
             * Properties of a ProductOption.
             * @memberof loomi.binary
             * @interface IProductOption
             * @augments loomi.binary.ProductOption.$Properties
             * @deprecated Use loomi.binary.ProductOption.$Properties instead.
             */

            /**
             * Shape of a ProductOption.
             * @typedef {loomi.binary.ProductOption.$Properties} loomi.binary.ProductOption.$Shape
             */

            /**
             * Constructs a new ProductOption.
             * @memberof loomi.binary
             * @classdesc Represents a ProductOption.
             * @constructor
             * @param {loomi.binary.ProductOption.$Properties=} [properties] Properties to set
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */
            var ProductOption = function (properties) {
                this.values = [];
                if (properties)
                    for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            };

            /**
             * ProductOption name.
             * @member {string} name
             * @memberof loomi.binary.ProductOption
             * @instance
             */
            ProductOption.prototype.name = "";

            /**
             * ProductOption values.
             * @member {Array.<string>} values
             * @memberof loomi.binary.ProductOption
             * @instance
             */
            ProductOption.prototype.values = $util.emptyArray;

            /**
             * Encodes the specified ProductOption message. Does not implicitly {@link loomi.binary.ProductOption.verify|verify} messages.
             * @function encode
             * @memberof loomi.binary.ProductOption
             * @static
             * @param {loomi.binary.ProductOption.$Properties} message ProductOption message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ProductOption.encode = function (message, writer, _depth) {
                if (!writer)
                    writer = $Writer.create();
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                if (message.name != null && $Object.hasOwnProperty.call(message, "name") && message.name !== "")
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.values != null && message.values.length)
                    for (var i = 0; i < message.values.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.values[i]);
                if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                    for (var i = 0; i < message.$unknowns.length; ++i)
                        writer.raw(message.$unknowns[i]);
                return writer;
            };

            /**
             * Decodes a ProductOption message from the specified reader or buffer.
             * @function decode
             * @memberof loomi.binary.ProductOption
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {loomi.binary.ProductOption & loomi.binary.ProductOption.$Shape} ProductOption
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ProductOption.decode = function (reader, length, _end, _depth, _target) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $Reader.recursionLimit)
                    throw $Error("max depth exceeded");
                var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.loomi.binary.ProductOption(), value;
                while (reader.pos < end) {
                    var start = reader.pos;
                    var tag = reader.tag();
                    if (tag === _end) {
                        _end = $undefined;
                        break;
                    }
                    var wireType = tag & 7;
                    switch (tag >>>= 3) {
                    case 1: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.stringVerify()).length)
                                message.name = value;
                            else
                                delete message.name;
                            continue;
                        }
                    case 2: {
                            if (wireType !== 2)
                                break;
                            if (!(message.values && message.values.length))
                                message.values = [];
                            message.values.push(reader.stringVerify());
                            continue;
                        }
                    }
                    reader.skipType(wireType, _depth, tag);
                    if (!reader.discardUnknown) {
                        $util.makeProp(message, "$unknowns", false);
                        (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                    }
                }
                if (_end !== $undefined)
                    throw $Error("missing end group");
                return message;
            };

            /**
             * Gets the type url for ProductOption
             * @function getTypeUrl
             * @memberof loomi.binary.ProductOption
             * @static
             * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
             * @returns {string} The type url
             */
            ProductOption.getTypeUrl = function(prefix) {
                if (prefix === $undefined)
                    prefix = "type.googleapis.com";
                return prefix + "/loomi.binary.ProductOption";
            };

            return ProductOption;
        })();

        binary.Image = (function() {

            /**
             * Properties of an Image.
             * @typedef {Object} loomi.binary.Image.$Properties
             * @property {string|null} [src] Image src
             * @property {number|null} [height] Image height
             * @property {number|null} [width] Image width
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */

            /**
             * Properties of an Image.
             * @memberof loomi.binary
             * @interface IImage
             * @augments loomi.binary.Image.$Properties
             * @deprecated Use loomi.binary.Image.$Properties instead.
             */

            /**
             * Shape of an Image.
             * @typedef {loomi.binary.Image.$Properties} loomi.binary.Image.$Shape
             */

            /**
             * Constructs a new Image.
             * @memberof loomi.binary
             * @classdesc Represents an Image.
             * @constructor
             * @param {loomi.binary.Image.$Properties=} [properties] Properties to set
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */
            var Image = function (properties) {
                if (properties)
                    for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            };

            /**
             * Image src.
             * @member {string} src
             * @memberof loomi.binary.Image
             * @instance
             */
            Image.prototype.src = "";

            /**
             * Image height.
             * @member {number} height
             * @memberof loomi.binary.Image
             * @instance
             */
            Image.prototype.height = 0;

            /**
             * Image width.
             * @member {number} width
             * @memberof loomi.binary.Image
             * @instance
             */
            Image.prototype.width = 0;

            /**
             * Encodes the specified Image message. Does not implicitly {@link loomi.binary.Image.verify|verify} messages.
             * @function encode
             * @memberof loomi.binary.Image
             * @static
             * @param {loomi.binary.Image.$Properties} message Image message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Image.encode = function (message, writer, _depth) {
                if (!writer)
                    writer = $Writer.create();
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                if (message.src != null && $Object.hasOwnProperty.call(message, "src") && message.src !== "")
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.src);
                if (message.height != null && $Object.hasOwnProperty.call(message, "height") && message.height !== 0)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.height);
                if (message.width != null && $Object.hasOwnProperty.call(message, "width") && message.width !== 0)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.width);
                if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                    for (var i = 0; i < message.$unknowns.length; ++i)
                        writer.raw(message.$unknowns[i]);
                return writer;
            };

            /**
             * Decodes an Image message from the specified reader or buffer.
             * @function decode
             * @memberof loomi.binary.Image
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {loomi.binary.Image & loomi.binary.Image.$Shape} Image
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Image.decode = function (reader, length, _end, _depth, _target) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $Reader.recursionLimit)
                    throw $Error("max depth exceeded");
                var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.loomi.binary.Image(), value;
                while (reader.pos < end) {
                    var start = reader.pos;
                    var tag = reader.tag();
                    if (tag === _end) {
                        _end = $undefined;
                        break;
                    }
                    var wireType = tag & 7;
                    switch (tag >>>= 3) {
                    case 1: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.stringVerify()).length)
                                message.src = value;
                            else
                                delete message.src;
                            continue;
                        }
                    case 2: {
                            if (wireType !== 0)
                                break;
                            if (value = reader.int32())
                                message.height = value;
                            else
                                delete message.height;
                            continue;
                        }
                    case 3: {
                            if (wireType !== 0)
                                break;
                            if (value = reader.int32())
                                message.width = value;
                            else
                                delete message.width;
                            continue;
                        }
                    }
                    reader.skipType(wireType, _depth, tag);
                    if (!reader.discardUnknown) {
                        $util.makeProp(message, "$unknowns", false);
                        (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                    }
                }
                if (_end !== $undefined)
                    throw $Error("missing end group");
                return message;
            };

            /**
             * Gets the type url for Image
             * @function getTypeUrl
             * @memberof loomi.binary.Image
             * @static
             * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
             * @returns {string} The type url
             */
            Image.getTypeUrl = function(prefix) {
                if (prefix === $undefined)
                    prefix = "type.googleapis.com";
                return prefix + "/loomi.binary.Image";
            };

            return Image;
        })();

        binary.Collection = (function() {

            /**
             * Properties of a Collection.
             * @typedef {Object} loomi.binary.Collection.$Properties
             * @property {number|Long|null} [id] Collection id
             * @property {string|null} [handle] Collection handle
             * @property {string|null} [title] Collection title
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */

            /**
             * Properties of a Collection.
             * @memberof loomi.binary
             * @interface ICollection
             * @augments loomi.binary.Collection.$Properties
             * @deprecated Use loomi.binary.Collection.$Properties instead.
             */

            /**
             * Shape of a Collection.
             * @typedef {loomi.binary.Collection.$Properties} loomi.binary.Collection.$Shape
             */

            /**
             * Constructs a new Collection.
             * @memberof loomi.binary
             * @classdesc Represents a Collection.
             * @constructor
             * @param {loomi.binary.Collection.$Properties=} [properties] Properties to set
             * @property {Array.<Uint8Array>} [$unknowns] Unknown fields preserved while decoding when enabled
             */
            var Collection = function (properties) {
                if (properties)
                    for (var keys = $Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            };

            /**
             * Collection id.
             * @member {number|Long} id
             * @memberof loomi.binary.Collection
             * @instance
             */
            Collection.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Collection handle.
             * @member {string} handle
             * @memberof loomi.binary.Collection
             * @instance
             */
            Collection.prototype.handle = "";

            /**
             * Collection title.
             * @member {string} title
             * @memberof loomi.binary.Collection
             * @instance
             */
            Collection.prototype.title = "";

            /**
             * Encodes the specified Collection message. Does not implicitly {@link loomi.binary.Collection.verify|verify} messages.
             * @function encode
             * @memberof loomi.binary.Collection
             * @static
             * @param {loomi.binary.Collection.$Properties} message Collection message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Collection.encode = function (message, writer, _depth) {
                if (!writer)
                    writer = $Writer.create();
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $util.recursionLimit)
                    throw $Error("max depth exceeded");
                if (message.id != null && $Object.hasOwnProperty.call(message, "id") && (typeof message.id === "object" ? message.id.low || message.id.high : message.id !== 0))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                if (message.handle != null && $Object.hasOwnProperty.call(message, "handle") && message.handle !== "")
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.handle);
                if (message.title != null && $Object.hasOwnProperty.call(message, "title") && message.title !== "")
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.title);
                if (message.$unknowns != null && $Object.hasOwnProperty.call(message, "$unknowns"))
                    for (var i = 0; i < message.$unknowns.length; ++i)
                        writer.raw(message.$unknowns[i]);
                return writer;
            };

            /**
             * Decodes a Collection message from the specified reader or buffer.
             * @function decode
             * @memberof loomi.binary.Collection
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {loomi.binary.Collection & loomi.binary.Collection.$Shape} Collection
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Collection.decode = function (reader, length, _end, _depth, _target) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (_depth === $undefined)
                    _depth = 0;
                if (_depth > $Reader.recursionLimit)
                    throw $Error("max depth exceeded");
                var end = length === $undefined ? reader.len : reader.pos + length, message = _target || new $root.loomi.binary.Collection(), value;
                while (reader.pos < end) {
                    var start = reader.pos;
                    var tag = reader.tag();
                    if (tag === _end) {
                        _end = $undefined;
                        break;
                    }
                    var wireType = tag & 7;
                    switch (tag >>>= 3) {
                    case 1: {
                            if (wireType !== 0)
                                break;
                            if (typeof (value = reader.int64()) === "object" ? value.low || value.high : value !== 0)
                                message.id = value;
                            else
                                delete message.id;
                            continue;
                        }
                    case 2: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.stringVerify()).length)
                                message.handle = value;
                            else
                                delete message.handle;
                            continue;
                        }
                    case 6: {
                            if (wireType !== 2)
                                break;
                            if ((value = reader.stringVerify()).length)
                                message.title = value;
                            else
                                delete message.title;
                            continue;
                        }
                    }
                    reader.skipType(wireType, _depth, tag);
                    if (!reader.discardUnknown) {
                        $util.makeProp(message, "$unknowns", false);
                        (message.$unknowns || (message.$unknowns = [])).push(reader.raw(start, reader.pos));
                    }
                }
                if (_end !== $undefined)
                    throw $Error("missing end group");
                return message;
            };

            /**
             * Gets the type url for Collection
             * @function getTypeUrl
             * @memberof loomi.binary.Collection
             * @static
             * @param {string} [prefix] Custom type url prefix, defaults to `"type.googleapis.com"`
             * @returns {string} The type url
             */
            Collection.getTypeUrl = function(prefix) {
                if (prefix === $undefined)
                    prefix = "type.googleapis.com";
                return prefix + "/loomi.binary.Collection";
            };

            return Collection;
        })();

        return binary;
    })();

    return loomi;
})();

module.exports = $root;
